import { compareDesc } from "date-fns";
import { createSelector } from "reselect";

import { IInvoice, InvoiceItemOrigin } from "interfaces/entities/invoice";
import { IWithRequestsState, createRequestFetchingSelector } from "store/requests/selectors";

import { InvoicesSelectorsNames } from "./actions";
import { IInvoicesViewState } from "./reducer";

export interface IWithInvoicesViewState {
  views: {
    invoices: IInvoicesViewState;
  };
}

export function getIsFetching(state: IWithInvoicesViewState & IWithRequestsState): boolean {
  return createRequestFetchingSelector(["FETCH_COLLECTION_INVOICE"])(state);
}

function sortByDate(a: IInvoice, b: IInvoice): number {
  return compareDesc(a.createdAt, b.createdAt);
}

export function invoicesSelector(state: IWithInvoicesViewState): IInvoice[] {
  return state.views.invoices.data;
}

export function shouldDisplayInvoice(invoice: IInvoice): boolean {
  const isTrialInvoice = invoice.items.length === 1 && invoice.items[0].origin === InvoiceItemOrigin.PlanTrial;
  return !isTrialInvoice;
}

export const getInvoicesData = createSelector(invoicesSelector, invoices =>
  invoices.filter(shouldDisplayInvoice).sort(sortByDate)
);

export function getIsInvoiceDownloading(state: IWithRequestsState): boolean {
  return createRequestFetchingSelector([InvoicesSelectorsNames.DOWNLOAD_INVOICE])(state);
}
